module.exports = __webpack_public_path__ + "static/media/blumira-web-logo-01.7b6f3229.png";